type QuantityRow = { value?: unknown }

/**
 * Linhas das tabelas de estoque com quantidade que o backend aceita. Os inputs guardam
 * `event.target.value` cru ('' quando a pessoa apaga) e o Joi recusa '' com "must be a number".
 * Ajuste aceita 0 (zerar estoque); entrada, baixa e transferência exigem > 0 (`positive()`
 * na baixa/transferência, e 0 na entrada não faz nada). Devolve `value` já numérico.
 */
export const validRows = <T extends QuantityRow>(rows: T[] | undefined, allowZero = false): (T & { value: number })[] =>
  (rows || [])
    .map((row) => ({ row, raw: row.value }))
    .filter(({ raw }) => raw !== null && raw !== undefined && String(raw).trim() !== '')
    .map(({ row, raw }) => ({ ...row, value: Number(raw) }))
    .filter(({ value }) => Number.isFinite(value) && (allowZero ? value >= 0 : value > 0))
